import querystring from 'querystring'

export default {
  props: {
    smartUrlPrefix: String,
    filterQuery: String,
  },
  computed: {
    listViewUrl() {
      const urlParts = [this.smartUrlPrefix]
      if (this.filterQuery) {
        const object = JSON.parse(this.filterQuery)
        if (object.userListViewId) {
          urlParts.push(object.userListViewId)
          delete object.userListViewId
        }
        const columnFilters = querystring.stringify(object)
        if (columnFilters) {
          urlParts.push(columnFilters)
        }
      }

      return `${urlParts.join('/')}`
    },
  },
}
